import React from 'react';
import { deliverypartneritem } from './Datatype';

interface props {
  deliverypartners: deliverypartneritem[];
  openedit: (item: deliverypartneritem) => void;
}

const DeliveryPartnerTable: React.FC<props> = ({ deliverypartners, openedit }) => {
  const rows = deliverypartners.map((item, i) => (
    <tr key={item._id || i}>
      <td style={{ width: '60px' }}>
        <select
          className="action-select"
          value=""
          onChange={(e) => {
            e.target.value === "edit" && openedit(item);
          }}
        >
          <option value="" disabled>{i + 1}</option>
          <option value="edit">edit</option>
        </select>
      </td>
      <td><strong>{item.name}</strong></td>
      <td>{item.phone}</td>
      <td><span className={`status-badge ${item.status}`}>{item.status}</span></td>
    </tr>
  ));

  return (
    <table className="grid">
      <thead>
        <tr>
          <th>action</th>
          <th>name</th>
          <th>phone</th>
          <th>status</th>
        </tr>
      </thead>
      <tbody>
        {rows.length > 0 ? rows : (
          <tr>
            <td colSpan={4} style={{ textAlign: 'center', padding: '16px' }}>No delivery partners found</td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default DeliveryPartnerTable;
